<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>{{
      translationService.getProductCSVTemplatesText()
    }}</mat-panel-title>
  </mat-expansion-panel-header>
  <button (click)="goToCreate()">
    {{ translationService.getCreateText() }}
  </button>
  <app-product-template-list></app-product-template-list>
</mat-expansion-panel>
